if(!global["bf"]) global["bf"] = {};
module.exports = global["bf"]["createLegacySlider"] = require("-!/builds/360psg/blank/savannah/node_modules/babel-loader/lib/index.js??ref--0!/builds/360psg/blank/savannah/src/frontend/slider-v1/index.js").default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-default-loader?bf.createLegacySlider!./src/frontend/slider-v1/index.js
// module id = 252
// module chunks = 2